<template>
  <div>
    <card-modal :showing="showing" class="px-4 py-2" @close="close()">
      <h2 class="font-bold text-3xl">Edit Note</h2>
      <span class="text-gray-400">Max 200 characters</span>
      <trashed-message v-if="note.deleted_at" class="mb-6" @restore="restore"> This note has been deleted. </trashed-message>
      <form class="mt-6" @submit.prevent="update">
        <textarea-input v-model="form.description" rows="4" :error="form.errors.description" class="w-full" />
        <div class="flex items-center justify-between mt-6">
          <div>
            <button v-if="! note.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Note</button>
          </div>
          <div class="flex items-center justify-end">
            <a class="border text-blue-800 border-blue-800 px-4 py-2 mr-4 cursor-pointer hover:text-white hover:bg-blue-600" @click.stop="close()">Cancel</a>
            <loading-button :loading="form.processing" class="btn-blue px-4 py-2" type="submit">Update Note</loading-button>
          </div>
        </div>
      </form>
    </card-modal>
  </div>
</template>

<script>
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import CardModal from '@/Shared/CardModal'

export default {
  components: {
    TrashedMessage,
    LoadingButton,
    TextareaInput,
    CardModal,
  },
  // remember: 'form',
  props:{
    note: Object,
  },
  emits: ['close'],
  data() {
    return {
      showing: true,
      form: this.$inertia.form({
        description : this.note.description,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/notes/${this.note.id}`, {
        onSuccess: () => {
          this.close()
        },
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this note?')) {
        this.form.delete(`/notes/${this.note.id}`, {
          onSuccess: () => {
            this.close()
          },
        })
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this note?')) {
        this.form.put(`/notes/${this.note.id}/restore`, {
          onSuccess: () => {
            this.close()
          },
        })
      }
    },
    close() {
      this.form.reset()
      this.showing = false
      this.$emit('close')
    },
  },
}
</script>
